import { useSelector } from 'react-redux';
import { SOFT_DELETED } from 'conversations-message-history/common-message-format/constants/messageDeleteStatus';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import ThreadViewPlaceholder from 'conversations-thread-view/thread-view/components/ThreadViewPlaceholder';
import ConversationMovedToTrash from '../../thread-deletion/components/ConversationMovedToTrash';
import { useCurrentViewIsProcessing } from '../../custom-views/hooks/useCurrentViewIsProcessing';
import { useViewCanSeeDeletedMessages } from '../../thread-list/hooks/useViewCanSeeDeletedMessages';
import { ViewProgressState } from 'svh-workspace-ui-lib/custom-views/public';
import InboxThreadOverview from './InboxThreadOverview';
import { useInboxViewMembers } from 'find-and-filter-data/view-members-data/public';
import { getCurrentInboxId } from 'conversations-inbox-lib/unified-inbox/public/selectors';
import { getCurrentViewId } from '../../thread-list/selectors/getCurrentViewId';
import { getStatus } from 'find-and-filter-data/view-members-schema/protected';
import { useView } from 'find-and-filter-data/views-data/public';
import { getUnreadThreadCount } from 'find-and-filter-data/views-schema/public';
import { View } from 'foundations-components/components/View';
import EmptyStateThread from './zero-states/EmptyStateThread';
import { jsx as _jsx } from "react/jsx-runtime";
const InboxMainViewContent = ({
  focusedThreadId
}) => {
  const showDeletedMessages = useViewCanSeeDeletedMessages();
  const inboxId = useSelector(getCurrentInboxId);
  const viewId = useSelector(getCurrentViewId);
  const {
    loading,
    viewMembers
  } = useInboxViewMembers({
    inboxId,
    skip: true,
    viewId: viewId || undefined
  });
  const threadListMember = viewMembers && focusedThreadId ? viewMembers.get(focusedThreadId) : {};
  const isThreadSoftDeletedBool = getStatus(threadListMember) === SOFT_DELETED;
  const showMovedToTrashState = isThreadSoftDeletedBool && !showDeletedMessages;
  const isCurrentViewEvaluating = useCurrentViewIsProcessing();
  const view = useView(inboxId, viewId);
  if (isCurrentViewEvaluating) {
    return /*#__PURE__*/_jsx(ViewProgressState, {});
  }
  if (showMovedToTrashState) {
    return /*#__PURE__*/_jsx(ConversationMovedToTrash, {});
  }
  if (focusedThreadId) {
    return /*#__PURE__*/_jsx(InboxThreadOverview, {
      focusedThreadId: focusedThreadId
    });
  }
  if (loading) {
    return /*#__PURE__*/_jsx(View, {
      blockSize: "100%",
      inlineSize: "100%",
      children: /*#__PURE__*/_jsx(ThreadViewPlaceholder, {})
    });
  }
  const shouldShowNoFocusedThreadView = view !== undefined && (getUnreadThreadCount(view) || 0) > 0;
  return /*#__PURE__*/_jsx(EmptyStateThread, {
    variant: shouldShowNoFocusedThreadView ? 'no-focused-thread' : 'no-unread-thread'
  });
};
InboxMainViewContent.displayName = 'InboxMainViewContent';
export default InboxMainViewContent;